






























































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TrainingSample extends Vue {
  @Prop({ default: null })
  readonly oportunity!: any;
}
